import createPreferenceStore from "./createPreferenceStore";

/** Autoplay the next playlist item when a video ends (default on). */
export const autoplayStore = createPreferenceStore({
    storageKey: "autoplay_enabled",
    eventName: "autoplay-changed",
    defaultValue: true,
    parse: (raw) => raw !== "false",
});

/** "Modo teatro" — widescreen stage layout on the content page. */
export const theaterStore = createPreferenceStore({
    storageKey: "player_theater_mode",
    eventName: "theater-mode-changed",
    defaultValue: false,
    parse: (raw) => raw === "true",
});

/**
 * Cheap static heuristic for devices that would struggle with the ambient
 * glow's large blur compositing: few cores or little RAM (deviceMemory is
 * Chromium-only; absent values don't count against the device).
 */
const deviceLikelyLowPower = () => {
    try {
        const cores = navigator.hardwareConcurrency || 0;
        const memoryGb = navigator.deviceMemory || 0;
        return (cores > 0 && cores < 4) || (memoryGb > 0 && memoryGb <= 2);
    } catch {
        return false;
    }
};

/**
 * "Iluminação cinematográfica" — ambient blur glow behind the player.
 * Without a stored choice, low-power devices start with it disabled; a
 * runtime FPS guard (see AmbientGlow) can also switch it off mid-session.
 */
export const ambientStore = createPreferenceStore({
    storageKey: "player_ambient_glow",
    eventName: "ambient-glow-changed",
    defaultValue: !deviceLikelyLowPower(),
    parse: (raw) => raw !== "false",
});

/** Playback speed, carried across videos and sessions. */
export const speedStore = createPreferenceStore({
    storageKey: "player_playback_rate",
    eventName: "playback-rate-changed",
    defaultValue: 1,
    parse: (raw) => {
        const value = parseFloat(raw);
        return Number.isFinite(value) && value >= 0.25 && value <= 2 ? value : 1;
    },
});
